// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiUrl: 'https://api-beta-v4.hemisphereapp.io',
  name: "education-beta",
  instanceType: "education",
  googleAnalyticsTag: '',
  timeToTake: 45,
  audioBaseDir: 'https://beta-cdn.hemisphereapp.io',
  videoBaseUrl: 'https://video.hemisphereapp.io',
  mainGameList: [],
  ratingList: [{
    question: 'What would you do if you had a deadline for tomorrow but you are nowhere near finishing the task?',
    ratingMedia: [

      {
        id: 1,
        audio: '/general2/902MWN04A.mp3',
        video: 258095795,
        thumbnail: '902MWN04V.jpg'
      },
      {
        id: 2,
        audio: '/general2/906MBY04A.mp3',
        video: 258096383,
        thumbnail: '906MBY04V.jpg'
      },
      {
        id: 3,
        audio: '/general2/908MAY04A.mp3',
        video: 258095871,
        thumbnail: '908MAY04V.jpg'
      },
      {
        id: 4,
        audio: '/general2/909FWN04A.mp3',
        video: 258095922,
        thumbnail: '909FWN04V.jpg'
      },
      {
        id: 5,
        audio: '/general2/914FBY04A.mp3',
        video: 258095973,
        thumbnail: '914FBY04V.jpg'
      },

    ]
  }

  ],
};
